import React from 'react';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

export const EmptyState = () => {
  const { t } = useTranslation();

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={t('Nessun footer menu trovato')}
      style={{ padding: '40px 0' }}
    />
  );
};
